module.exports = __webpack_public_path__ + "static/media/logoWithText.fef528c4.png";